import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Caring Haven</h2>
            <p>
              We are revolutionizing the search for personal care homes by simplifying the process.
              With just one call, you can inquire and book appointments for tours at any of our locations.
              We implement a real-time census system to reflect current availability, and even provide
              floor plans online so you can view available rooms before your visit.
            </p>
            <p>
              Our mission is to create a warm, supportive environment where residents can maintain their
              dignity, independence, and quality of life while receiving the care they need. We believe
              that every individual deserves to be treated with respect, compassion, and understanding.
            </p>
            
            <div className="about-features">
              <div className="feature">
                <h4>🌟 Experienced Staff</h4>
                <p>Our team consists of qualified healthcare professionals with years of experience in elderly care.</p>
              </div>
              <div className="feature">
                <h4>🏡 Home-like Environment</h4>
                <p>We've created a comfortable, familiar atmosphere that feels like home rather than an institution.</p>
              </div>
              <div className="feature">
                <h4>👥 Personalized Care</h4>
                <p>Each resident receives individualized care plans tailored to their specific needs and preferences.</p>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <img 
              src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
              alt="Caring staff providing compassionate care" 
              className="about-main-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;